"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasFleetPrivilege = exports.hasCustomTagsPrivileges = exports.hasFotaPrivilages = exports.hasPotaPrivilages = exports.featureEnabled = exports.hasClaim = void 0;
var http_1 = require("./http");
var claims_1 = require("../constants/claims");
var app_1 = __importDefault(require("../constants/app"));
var SessionStorage_1 = __importDefault(require("../services/SessionStorage"));
var getClaims = function () { return SessionStorage_1.default.get(app_1.default.SESSION_STORAGE.LEGACY.CLAIMS); };
var isAdmin = function () { return SessionStorage_1.default.get(app_1.default.SESSION_STORAGE.LEGACY.IS_ADMIN); };
var isDtna = function () { return SessionStorage_1.default.get(app_1.default.SESSION_STORAGE.LEGACY.IS_DTNA); };
var isRoot = function () { return SessionStorage_1.default.get(app_1.default.SESSION_STORAGE.LEGACY.IS_ROOT); };
var isXota = function () { return SessionStorage_1.default.get(app_1.default.SESSION_STORAGE.LEGACY.IS_XOTA); };
var isSafety = function () { return SessionStorage_1.default.get(app_1.default.SESSION_STORAGE.LEGACY.IS_SAFETY); };
var isCsAgent = function () { return SessionStorage_1.default.get(app_1.default.SESSION_STORAGE.LEGACY.IS_CS_AGENT); };
var isCsAdmin = function () { return SessionStorage_1.default.get(app_1.default.SESSION_STORAGE.LEGACY.IS_CS_ADMIN); };
var isOps = function () { return SessionStorage_1.default.get(app_1.default.SESSION_STORAGE.LEGACY.IS_OPS); };
/**
 * Checks whether or not the logged in user has the given permissions, or any special cases apply
 *
 * @param {string|string[]|string[][]} claims - a string with a single permission to check, or an
 * array of objects to check, all of which must be satisfied. Each of those objects may be a string
 * or an array containing strings, any of which can be satisfied.
 * @param {SpecialCases} specialCases - optional, an object of special cases (root, admin, dtna)
 * any of which may also satisfy the check. By default, any of these satisfy the check. dtna is
 * only acceptable if a missing claim is for viewing data, and if the user does not have a role on
 * the current fleet.
 */
var hasClaim = function (claims, withSpecialCases) {
    if (withSpecialCases === void 0) { withSpecialCases = { root: true, admin: true, dtna: true }; }
    var specialCases = __assign({}, withSpecialCases);
    specialCases.root = specialCases.root && isRoot();
    specialCases.dtna = specialCases.dtna && isDtna();
    specialCases.admin = specialCases.admin && isAdmin();
    var userClaims = SessionStorage_1.default.get(app_1.default.SESSION_STORAGE.LEGACY.CLAIMS) || [];
    var sanitized = !Array.isArray(claims)
        ? [[claims]]
        : __spreadArray([], claims, true).map(function (claim) { return (Array.isArray(claim) ? claim : [claim]); });
    return sanitized.every(function (claimSet) { return claimSet.some(function (claim) {
        var isBlocked = claims_1.BLOCKED_CLAIMS.indexOf(claim) >= 0;
        var isBlockedDtna = isBlocked || claims_1.BLOCKED_DTNA_CLAIMS.indexOf(claim) >= 0;
        var isBlockedFleetAdmin = isBlocked || claims_1.BLOCKED_FLEET_ADMIN_CLAIMS.indexOf(claim) >= 0;
        return (specialCases.root && !isBlocked)
            || (specialCases.dtna && !isBlockedDtna)
            || (specialCases.admin && !isBlockedFleetAdmin)
            || (userClaims.includes(claim) && !isBlocked)
            || false;
    }); });
};
exports.hasClaim = hasClaim;
/** Is the user an Admin, DNTA, or Root? I'm calling this an 'advanced' user */
var isAdvancedUser = function () { return isAdmin() || isDtna() || isRoot(); };
var isInternalUser = function () { return isDtna() || isRoot(); };
var hasPota = function () { return (0, exports.hasClaim)(claims_1.POTAClaim.ASSIGN) || (0, exports.hasClaim)(claims_1.POTAClaim.READ) || (0, exports.hasClaim)(claims_1.POTAClaim.MANAGE); };
var isDealer = function () { return SessionStorage_1.default.get(app_1.default.SESSION_STORAGE.LEGACY.TAN_ID) === app_1.default.SESSION_STORAGE.VIRTUAL_TECHNICIAN_CUSTOMER; };
var hasVtDash = function () { return isDealer() || isDtna() || isRoot(); };
var isDtnaUser = function () { return isDtna() && !isAdmin(); };
var isDtnaOrFleetAdmin = function () { return isAdmin() || isRoot(); };
/**
 * Checks if the user has access to VtDash and is already on a VtDash route
 */
var shouldUseVtDash = function () { return (hasVtDash() && (0, http_1.isOnVtDash)()); };
var featureEnabled = function (feature) { return claims_1.BLOCKED_FEATURES.indexOf(feature) === -1; };
exports.featureEnabled = featureEnabled;
var hasPotaPrivilages = function (user) { return !!user.Customer
    && user.Customer.POTA
    && (0, exports.hasClaim)(claims_1.POTAClaim.READ); };
exports.hasPotaPrivilages = hasPotaPrivilages;
var hasFotaPrivilages = function (user) { return !!user.Customer
    && user.Customer.FOTA
    && (0, exports.hasClaim)(claims_1.FOTAClaim.READ); };
exports.hasFotaPrivilages = hasFotaPrivilages;
var hasCustomTagsPrivileges = function () {
    var customTagsClaims = [claims_1.VehiclesClaim.UPDATE];
    return (0, exports.hasClaim)([customTagsClaims]);
};
exports.hasCustomTagsPrivileges = hasCustomTagsPrivileges;
/**
 * Used to check whether any specific permission available from session storage
 *
 * @param {FeatureClaim} claim - a value with a single permission to check any one of the
 * permission is satisfied.
 * @returns true if permission exists in session storage
 */
var hasFleetPrivilege = function (claim) {
    var userClaims = SessionStorage_1.default.get(app_1.default.SESSION_STORAGE.LEGACY.CLAIMS) || [];
    var isClaimsBlocked = claims_1.BLOCKED_CLAIMS.indexOf(claim) >= 0;
    return ((userClaims && userClaims.length === 0) || !claim)
        ? false
        : userClaims.includes(claim) && !isClaimsBlocked;
};
exports.hasFleetPrivilege = hasFleetPrivilege;
var claimsModule = {
    getClaims: getClaims,
    hasClaim: exports.hasClaim,
    hasCustomTagsPrivileges: exports.hasCustomTagsPrivileges,
    hasFleetPrivilege: exports.hasFleetPrivilege,
    hasPota: hasPota,
    hasVtDash: hasVtDash,
    isAdmin: isAdmin,
    isAdvancedUser: isAdvancedUser,
    isDealer: isDealer,
    isDtna: isDtna,
    isDtnaOrFleetAdmin: isDtnaOrFleetAdmin,
    isDtnaUser: isDtnaUser,
    isInternalUser: isInternalUser,
    isRoot: isRoot,
    isXota: isXota,
    isSafety: isSafety,
    isCsAgent: isCsAgent,
    isCsAdmin: isCsAdmin,
    isOps: isOps,
    shouldUseVtDash: shouldUseVtDash,
    get: getClaims,
    has: exports.hasClaim,
};
exports.default = claimsModule;
